import 'base-styles/reset.sss';

import { h, render } from 'preact';
import PrimeCheckInApp from 'base/primeCheckIn/primeCheckInApp';

let publicPath = '';

try {
	let url = location.origin + location.pathname.replace(/\/[^/]*$/, '/');
	if (location.protocol === 'about:' && window.parent !== window) {
		url = window.parent.location.origin + window.parent.location.pathname.replace(/\/[^/]*$/, '/');
	}

	publicPath = url + (window.__RELATIVE_ROOT__ || '');
	// eslint-disable-next-line no-undef
	__webpack_public_path__ = publicPath;
} catch (e) {}

render(<PrimeCheckInApp />, document.body);

if ('serviceWorker' in navigator) {
	window.addEventListener('load', async () => {
		try {
			const worker = new URL(publicPath + 'primeCheckInWorker.js?v=' + window.__BUILD_DATE__);
			worker.searchParams.set('a', window.__INITIAL_STATE__?.appData?.urls?.roots?.media);
			await navigator.serviceWorker.register(worker.toString());
		} catch (err) {
			console.log('Could not register worker', err);
		}
	});
}